import React from "react";

// import assets
import LogoFullSrc from "../../brand/logo-full.png";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-shell">
        <div className="footer-cta">
          <div>
            <span className="footer-kicker">Build your next chapter</span>
            <h2>Ready to move your career or team forward?</h2>
          </div>
          <a className="button footer-cta-button" href="/contact">
            Start a conversation
            <span aria-hidden="true">&rarr;</span>
          </a>
        </div>

        <div className="footer-grid">
          <div className="footer-intro">
            <a className="footer-brand" href="/" aria-label="Lovapex Tech home">
              <img alt="Lovapex Tech" src={LogoFullSrc} />
            </a>
            <p>
              Connecting ambitious people and growing teams through thoughtful,
              human-first technology recruitment.
            </p>
            <address>Philadelphia, PA 19147, United States</address>
          </div>

          <div className="footer-column">
            <h3>Explore</h3>
            <nav aria-label="Footer navigation">
              <a href="/">Home</a>
              <a href="/about">About</a>
              <a href="/careers">Careers</a>
              <a href="/product">Product</a>
              <a href="/contact">Contact</a>
            </nav>
          </div>

          <div className="footer-column">
            <h3>Get in touch</h3>
            <a href="mailto:hr@lovapextech.com">hr@lovapextech.com</a>
            <a href="tel:+17088401141">(708) 840-1141</a>
          </div>

          <div className="footer-column footer-hours">
            <h3>Working hours</h3>
            <p>
              <span>Mon–Fri</span>
              <strong>9:00 AM–6:00 PM</strong>
            </p>
            <p>
              <span>Saturday</span>
              <strong>10:00 AM–2:00 PM</strong>
            </p>
            <p>
              <span>Sunday</span>
              <strong>Closed</strong>
            </p>
            <small>Eastern Time</small>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Lovapex Tech. All rights reserved.
          </p>
          <a href="/privacy-policy">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
